import React, { useEffect, useState } from 'react';
import style from './Milestone.module.css';
import DropTarget from './DragAndDrop/DropTarget';
import dotsThreeIcon from '../../../../assets/img/DotsThree.svg';
import { Dropdown } from 'react-bootstrap';
import EditBox from 'pages/projects/kanban/shared/EditBox';
import AddMilestoneCard from './AddMilestoneCard';
import { useDrop, useDrag } from 'react-dnd';
import boardToast, { TOAST_TYPE } from '../utils/boardToast';
import arrowLeft from '../../../../assets/img/arrow-left-icon.svg';
import editStatus from '../../../../assets/img/edit-status.svg';
import delete3 from '../../../../assets/img/delete3.svg';
import note from '../../../../assets/img/note.svg';
import editIcon from '../../../../assets/img/edit-pencil.svg';
import { getPlainText } from 'utils/Helpers';
import duplicate from '../../../../assets/img/duplicate.svg';
import movecards from '../../../../assets/img/movecards.svg';
import archiveIcon from '../../../../assets/img/archived.svg';
import { useSocket } from '../context/SocketContext';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <div
    style={{ cursor: 'pointer' }}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}>
    {children}
  </div>
));

export default function ChannelWrapper({
  name,
  milestones,
  handleDrop,
  handleMilestoneClick,
  handleSubmitChannel,
  handleDeleteChannel,
  projectBoardId,
  id,
  cancelEditChannelName,
  viewMode,
  progressBarList,
  isProjectRelatedBoard,
  handleDeleteMilestone,
  handleSubtaskClick,
  openSubtasks,
  setOpenSubtasks,
  members,
  priorityOptions,
  index,
  moveChannel,
  statusOptions,
  handleCloneMilestone,
  defaultLabels,
  reminderOptions,
  handlecollapseChannel,
  defaultCollapsed,
  channelStatus,
  setAddStatusOpen,
  handleArchiveMilestone,
  setInstructionsOpen,
  channelDetails,
  handleCloneChannel,
  handleArchiveChannelMilestones,
  showArchivedCards,
  isTemplateActive
}) {
  const socket = useSocket();
  const [isClosedStatus, setClosedStatus] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);
  const [hasInstruction, setHasInstruction] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [milestoneIds, setMilestoneIds] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const dropdownRef = React.useRef(null);
  const copyInputRef = React.useRef(null);
  const [viewType, setViewType] = useState('dropdown');
  const [copyListName, setCopyListName] = useState('');
  const [{ isOver: isCardOver }, cardDropRef] = useDrop(
    () => ({
      accept: 'MILESTONE_CARD',
      canDrop: () => !viewMode,
      drop: (item) => handleDrop(item, { name: name, _id: id }),
      collect: (monitor) => ({
        isOver: monitor.isOver()
      })
    }),
    [id, name, viewMode, handleDrop]
  );

  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: 'CHANNEL',
      item: { id, index },
      canDrag: !viewMode,
      collect: (monitor) => ({
        isDragging: monitor.isDragging()
      })
    }),
    [id, index, viewMode]
  );

  const [{ isOver: isChannelOver }, channelDropRef] = useDrop(
    () => ({
      accept: 'CHANNEL',
      canDrop: () => !viewMode,
      hover: (item) => {
        if (viewMode) return;
        if (item.index !== index) {
          moveChannel(item.index, index, false); // false → don’t emit socket yet
          item.index = index;
        }
      },
      drop: (item) => {
        if (viewMode) return;
        moveChannel(item.index, index, true); // true → final emit
      },
      collect: (monitor) => ({
        isOver: monitor.isOver()
      })
    }),
    [index, viewMode]
  );

  const filterMilestones = milestones.filter(
    (value) => value?.milestoneKBStatus?._id && value?.milestoneKBStatus?._id === id
  );

  const [showRenameBox, setShowRenameBox] = useState(false);

  // NEW: local collapse state
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed || false);

  const handleSubmit = (value) => {
    const trimmedValue = value.trim();
    if (trimmedValue === name) {
      setShowRenameBox(false);
      return;
    }
    if (progressBarList?.some((status) => status.name === value)) {
      boardToast('Channel name already exists.', TOAST_TYPE.ERROR);
      return;
    }
    handleSubmitChannel(value);
    setShowRenameBox(false);
  };

  useEffect(() => {
    if (!id) {
      setShowRenameBox(true);
    }
  }, [id]);

  useEffect(() => {
    if (viewMode) setShowRenameBox(false);
  }, [viewMode]);

  const handleCopyList = () => {
    const trimmedName = copyListName.trim();

    if (!trimmedName) {
      boardToast('List name is required', TOAST_TYPE.ERROR);
      return;
    }

    if (trimmedName.length > 24) {
      boardToast('List name can be max 24 characters', TOAST_TYPE.ERROR);
      return;
    }

    handleCloneChannel(id, trimmedName);
    setCopyListName('');
    setViewType('dropdown');
    setShowDropdown(false);
  };

  const handleMoveList = (destinationChannel) => {
    const trimmedName = copyListName.trim();
    try {
      socket.emit('move-milestones', {
        destinationChannelId: destinationChannel._id,
        destinationName: destinationChannel.name,
        milestoneIds,
        projectBoardId
      });
    } catch (err) {
      console.log('error', err);
    }

    setViewType('dropdown');
    setShowDropdown(false);
  };

  useEffect(() => {
    if (channelDetails) {
      let plaintext = getPlainText(channelDetails?.instruction);

      if (plaintext.length > 0) {
        setHasInstruction(true);
      } else {
        setHasInstruction(false);
      }
    }
  }, [channelDetails]);

  useEffect(() => {
    if (channelStatus) {
      setClosedStatus(channelStatus.value === 'close');
    }
  }, [channelStatus]);

  useEffect(() => {
    const filteredMilestones = milestones.filter(
      (value) => value?.milestoneKBStatus?._id && value?.milestoneKBStatus?._id === id
    );
    if (filteredMilestones.length > 0) {
      let milestoneIdarray = filteredMilestones.map((x) => x._id);
      setMilestoneIds(milestoneIdarray);
    } else {
      setMilestoneIds([]);
    }
  }, [milestones]);

  const handleClose = () => {
    setShowRenameBox(false);
    cancelEditChannelName();
  };

  const handleValidateDeleteChannel = () => {
    if (filterMilestones?.length > 0) {
      boardToast('Please move all milestones before deleting the channel.', TOAST_TYPE.ERROR);
    } else {
      handleDeleteChannel();
    }
  };

  // 👉 If collapsed: show only the side wrapper; clicking it expands again
  if (isCollapsed) {
    return (
      <div className={`side_wrapper ${isCardOver ? 'side_wrapper_active' : ''}`}>
        <div
          className={style.side_wrapper_inner}
          onClick={() => {
            setIsCollapsed(false);
            if (!viewMode) handlecollapseChannel(id, false);
          }}
          ref={(node) => dragRef(channelDropRef(cardDropRef(node)))}
          style={{ cursor: 'pointer', opacity: isDragging ? 0.5 : 1 }}>
          {name}
        </div>
        {filterMilestones.length > 0 && <p className="grey_text">{filterMilestones.length}</p>}
      </div>
    );
  }

  // 👉 Expanded view (default)
  return (
    <div
      className={`${style.column_drop_area} ${isCardOver ? style.column_drop_area_active : ''}`}
      ref={(node) => channelDropRef(cardDropRef(node))}>
      <div
      className={`${style.task_wrapper} ${hasScroll ? style.scroll_div : ''}`}
      ref={dragRef}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: 'pointer' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={(e) => {
        setIsHovered(false);
        // setViewType('dropdown');
        const dropdownEl = dropdownRef.current;
        const nextTarget = e.relatedTarget;

        // if (!dropdownEl) { 
        //   setShowDropdown(false);
        //   return;
        // }

        // if (nextTarget && nextTarget instanceof Node) {
        //   if (dropdownEl.contains(nextTarget)) return;
        // }

        // setShowDropdown(false);
      }}>
      <div className={`${style.task_wrapper_heading} ${filterMilestones.length === 0 && 'pb-0'}`}>
        {showRenameBox ? (
          <EditBox title={name} onClose={handleClose} handleSubmit={handleSubmit} />
        ) : (
          <>
            <div
              style={{ cursor: viewMode ? 'default' : 'pointer' }}
              className={style.header_elipses}
              onClick={() => {
                if (!viewMode) setShowRenameBox(true);
              }}>
              {name}
              {hasInstruction && (
                <button
                  type="button"
                  className={`${style.instructions_wrapper}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setInstructionsOpen();
                  }}>
                  <img src={note} alt="note" className={style.instructions_icon} />
                </button>
              )}
              {filterMilestones.length > 0 && (
                <span className="grey_text cards_count"> {filterMilestones.length}</span>
              )}{' '}
            </div>
            <div></div> {/* Collapse button / icon */}
            <div className="d-flex align-content-center">
              {channelStatus?.value === 'close' && (
                <span className={`small_text ${style.hover_text}`}>{channelStatus?.name} </span>
              )}

              <button
                type="button"
                onClick={() => {
                  setIsCollapsed(true);
                  if (!viewMode) handlecollapseChannel(id, true);
                }}
                className={`${style.collapse_btn} ${style.hover_img}`}
                // style is optional if you handle it in CSS
                style={{
                  border: 'none',
                  background: 'transparent',
                  marginLeft: '10px',
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
                title="Collapse column">
                <img src={arrowLeft} alt="arrowLeft" className={`${style.arrowLeft_icon} ${style.opacity5}`} />
              </button>
              {!viewMode && (
                <div className={`${style.hover_img} ${style.board_drp}`} ref={dropdownRef}>
                  <Dropdown
                    keyboard={false}
                    show={showDropdown}
                    autoClose="outside"
                    onToggle={(isOpen) => {
                      setShowDropdown(isOpen);
                      if (!isOpen) setViewType('dropdown');
                    }}>
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                      <img
                        src={dotsThreeIcon}
                        alt="menu"
                        className={`${style.menu_channel} ${style.opacity5}`}
                        onClick={() => setShowDropdown((prev) => !prev)}
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu renderOnMount>
                      {viewType === 'dropdown' && (
                        <>
                          <Dropdown.Item onClick={handleValidateDeleteChannel}>
                            <img src={delete3} alt="delete" className="featherdrowpdown-icon" /> Delete
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              setAddStatusOpen(true);
                              setShowDropdown(false);
                            }}>
                            <img src={editStatus} className="featherdrowpdown-icon" alt="menu" />
                            Edit Statuses
                          </Dropdown.Item>

                          {!hasInstruction && (
                            <Dropdown.Item
                              onClick={() => {
                                setInstructionsOpen();
                                setShowDropdown(false);
                              }}>
                              <img src={editIcon} className="featherdrowpdown-icon" alt="menu" />
                              Add Instructions
                            </Dropdown.Item>
                          )}

                          <Dropdown.Item
                            onClick={(e) => {
                              e.stopPropagation();
                              setCopyListName(name);
                              setViewType('copycolumns');

                              // Move cursor to end after render
                              setTimeout(() => {
                                if (copyInputRef.current) {
                                  const el = copyInputRef.current;
                                  el.focus();
                                  el.setSelectionRange(el.value.length, el.value.length);
                                }
                              }, 0);
                            }}>
                            <img src={duplicate} alt="duplicate" className="featherdrowpdown-icon" />
                            Copy list
                          </Dropdown.Item>
                          {filterMilestones.length > 0 && (
                            <>
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // setCopyListName(name);
                                  setViewType('movecolumns');
                                }}>
                                <img src={movecards} alt="movecards" className="featherdrowpdown-icon" />
                                Move all cards in this list
                              </Dropdown.Item>

                              {!showArchivedCards && (
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleArchiveChannelMilestones();
                                  }}>
                                  <img
                                    src={archiveIcon}
                                    width={16}
                                    height={16}
                                    alt="movecards"
                                    className="featherdrowpdown-icon"
                                  />
                                  Archive all cards
                                </Dropdown.Item>
                              )}
                            </>
                          )}
                        </>
                      )}

                      {viewType === 'copycolumns' && (
                        <div className={style.copy_list_popover}>
                          <div className={style.copy_list_header}>
                            <img
                              src={arrowLeft}
                              alt="arrowLeft"
                              className={style.arrowLeft}
                              onClick={(e) => {
                                e.stopPropagation();
                                setViewType('dropdown');
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                            <span>Copy list</span>
                            <button
                              className={style.copy_list_close}
                              onClick={() => {
                                setViewType('dropdown');
                                setShowDropdown(false);
                              }}>
                              ✕
                            </button>
                          </div>

                          <div className={style.copy_list_body}>
                            <label className={style.copy_list_label}>Name</label>
                            <textarea
                              ref={copyInputRef}
                              className={style.copy_list_input}
                              value={copyListName}
                              maxLength={24}
                              onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  e.nativeEvent.stopImmediatePropagation();

                                  requestAnimationFrame(() => {
                                    setViewType('dropdown');
                                  });
                                }
                              }}
                              onChange={(e) => setCopyListName(e.target.value)}
                              autoFocus
                            />
                            {/* <div className={style.copy_list_counter}>{copyListName.length}/24</div> */}
                          </div>

                          <button className={style.copy_list_button} onClick={handleCopyList}>
                            Create list
                          </button>
                        </div>
                      )}

                      {viewType === 'movecolumns' && (
                        <div className={style.copy_list_popover}>
                          <div className={style.copy_list_header}>
                            <img
                              src={arrowLeft}
                              alt="arrowLeft"
                              className={style.arrowLeft}
                              onClick={(e) => {
                                e.stopPropagation();
                                setViewType('dropdown');
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                            <span>Move all cards in list</span>
                            <button
                              className={style.copy_list_close}
                              onClick={() => {
                                setViewType('dropdown');
                                setShowDropdown(false);
                              }}>
                              ✕
                            </button>
                          </div>
                          <div className={style.move_list_body}>
                            {progressBarList.map((channel) => {
                              return (
                                <div
                                  onClick={() => {
                                    handleMoveList(channel);
                                  }}
                                  key={channel._id}
                                  className={`${style.move_list_item} ${channel._id === id ? style.move_list_item_disabled : ''}`}>
                                  {channel.name}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      <DropTarget
        channel={name}
        milestones={filterMilestones}
        handleMilestoneClick={handleMilestoneClick}
        isOver={isCardOver}
        viewMode={viewMode || isClosedStatus}
        handleDeleteMilestone={handleDeleteMilestone}
        handleSubtaskClick={handleSubtaskClick}
        openSubtasks={openSubtasks}
        setOpenSubtasks={setOpenSubtasks}
        members={members}
        projectBoardId={projectBoardId}
        statusId={id}
        statusName={name}
        isProjectRelatedBoard={isProjectRelatedBoard}
        priorityOptions={priorityOptions}
        statusOptions={statusOptions}
        handleCloneMilestone={handleCloneMilestone}
        defaultLabels={defaultLabels}
        reminderOptions={reminderOptions}
        handleArchiveMilestone={handleArchiveMilestone}
        isHovered={isHovered}
        setHasScroll={setHasScroll}
        isTemplateActive={isTemplateActive}
      />
      </div>
    </div>
  );
}
